<template>
  <div id="map-cpn" ref="map-cpn">
    <header class="header" v-if="!isSizeSm" ref="header">ヘッダー<a-button v-on:click="$_changeLang">{{language}}(日/英)</a-button></header>
    <div class="map-wrapper" v-bind:style="mapWrapperStyle">
      <DynamicMap
        v-bind:isSizeSm="isSizeSm"
        v-bind:address="address"
        v-bind:language="language"
        v-bind:loginFlag="loginFlag"
        v-bind:priceDiv="priceDiv"
        v-bind:crmFlag="crmFlag"
        v-bind:ssoSubscriptionId="ssoSubscriptionId"
        v-on:map-components-load-finished="$_handleResize">
      </DynamicMap>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import DynamicMap from '@/components/map-components/DynamicMap.vue'

export default {
  components: {
    DynamicMap
  },
  mounted() {
    const onResize = _.debounce(this.$_handleResize, 100)
    window.addEventListener('resize', onResize)
    this.$once('hook:beforeDestroy', function() {
      window.removeEventListener('resize', onResize)
    })
  },
  data() {
    return {
      isSizeSm: false,
      //address: "東京都千代田区学士会館",
      address: '',
      loginFlag: true,
      //loginFlag: false,
      language: 'ja',
      ssoSubscriptionId: '00000000',
      priceDiv: this.CONST_DATA.PRICE_DIV.PRICE_A,
      crmFlag: '0'
    }
  },
  created() {
    this.getAuthData();
  },
  computed: {
    mapWrapperStyle() {
      const headerHeight = this.isSizeSm ? '0' : '40'
      return {
        height: `calc(105vh - ${headerHeight}px - 96px - 40px - 32px)`
      }
    }
  },
  methods: {
    /**
     * リサイズハンドラ。dynamic-mapのサイズを確定させる
     */
    $_handleResize() {
      const appSize = this.$_getRefSize('map-cpn')
      //ブレークポイントを640pxと仮決め
      this.isSizeSm = appSize.width < 1024
    },
    $_getRefSize(refName) {
      const size = {
        height: 0,
        width: 0
      }
      let ref = this.$refs[refName]
      if (!ref) {
        return size
      }
      if('$el' in ref) {
        ref = ref.$el
      }
      size.height = ref.offsetHeight
      size.width = ref.offsetWidth
      return size
    },
    $_changeLang() {
      if(this.language === 'ja') {
        this.language = 'en'
      } else {
        this.language = 'ja'
      }
    },
    async getAuthData() {
      const authData = await this.$repositories("user").postUser();
      if (authData.isError) {
        return;
      }
      if (authData.data) {
        this.ssoSubscriptionId = authData.data.ssoSubscriptionId || "00000000";
        this.priceDiv = authData.data.priceDiv || 10;
        this.crmFlag = authData.data.crmFlag || "0";
      }
    }
  }
}
</script>

<style scoped>

@import "./styles.scss";

</style>